/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PolicyBuildProfileListing = {
    uuid: string;
    identifier: string;
    label: string;
    prepared_for?: string;
    requirement_sets?: Array<string>;
    classification?: string;
    layout?: PolicyBuildProfileListing.layout;
}

export namespace PolicyBuildProfileListing {

    export enum layout {
        SCREEN = 'screen',
        PRINT = 'print',
    }


}
